export default __webpack_public_path__ + "static/media/question-timer.3fb40e55.png";